import Vue from 'vue'
import { API_BASE } from '@/config/api'

const STORAGE_KEY = 'qiming.employee'

// 登录状态在多个路由页面之间共享，放在这里统一维护
export const state = Vue.observable({
  employee: null,
  // 只在「正在向后端确认员工登录态」时为 true。
  // 初始为 false：公开页（如患者建档页）不会调用 ensureSession，
  // 若初始为 true，App.vue 的加载遮罩就永远不消失。
  checkingSession: false
})

let restoreTask = null

function readStoredEmployee () {
  try {
    const raw = localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    return null
  }
}

async function restoreSession () {
  state.checkingSession = true
  const stored = readStoredEmployee()
  if (stored) {
    state.employee = stored
  }
  try {
    const response = await fetch(`${API_BASE}/api/auth/me`, { credentials: 'include' })
    const result = await response.json()
    state.employee = response.ok && result.code === 0 ? result.data : null
  } catch (error) {
    // 服务不可用时保留本地缓存的登录信息，避免刷新页面就直接退出
    state.employee = stored
  } finally {
    state.checkingSession = false
  }
  return state.employee
}

// 每次加载只向后端确认一次登录状态，路由守卫和页面都会等待这个结果
export function ensureSession () {
  if (!restoreTask) {
    restoreTask = restoreSession()
  }
  return restoreTask
}

export function setEmployee (employee) {
  state.employee = employee || null
  state.checkingSession = false
}

export function clear () {
  state.employee = null
  localStorage.removeItem(STORAGE_KEY)
  sessionStorage.removeItem(STORAGE_KEY)
}

export async function logout () {
  try {
    await fetch(`${API_BASE}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include'
    })
  } catch (error) {
    // 服务不可用时本地也要退出登录
  } finally {
    clear()
  }
}
